__turbopack_context__.v({
  "card": "oKdkDW_card",
  "content": "oKdkDW_content",
  "header": "oKdkDW_header",
  "imageWrapper": "oKdkDW_imageWrapper",
});
